import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { POS_MAX_BULK_SERVE_QUANTITY } from 'Common/Constants';
import { LoadingBase } from 'Components/';
import * as POSSelectors from 'PointOfSale/selectors';
import * as CommonStateSelectors from 'State/selectors';
import LookUpContainer from 'PointOfSale/modules/lookup/container/LookUpContainer';
import CEPComponent from 'PointOfSale/modules/cepCard/component/CEPComponent';
import { incrementServedMealsCount } from 'PointOfSale/modules/cepCard/state/actions';
import { createToast, toastType } from 'Common/ToastHelper';

class CEPContainer extends Component {
  state = {
    activeTabIndex: 0,
  };

  isValidIncrement(count) {
    if (count < 1) {
      createToast(toastType.error, 'Error', 'Please enter 1 or greater.');
      return false;
    }

    if (count > POS_MAX_BULK_SERVE_QUANTITY) {
      createToast(
        toastType.error,
        'Error',
        `Please enter ${POS_MAX_BULK_SERVE_QUANTITY} or less.`
      );
      return false;
    }
    return true;
  }

  incrementServe = (countStr, redirectToTMS) => {
    const count = parseInt(countStr, 10);
    if (!this.isValidIncrement(count)) {
      return;
    }

    this.props.incrementServedMealsCount(count);
    if (redirectToTMS) {
      this.setState({ activeTabIndex: 0 });
    }
  };

  changeTab = (e, { activeIndex }) => {
    this.setState({ activeTabIndex: activeIndex });
  };

  render() {
    const {
      showLookUp,
      lastMealServedAt,
      servedMealsCount,
      fetching,
      offsetMinutes,
    } = this.props;

    if (fetching) {
      return <LoadingBase flexible />;
    }

    if (showLookUp) {
      return <LookUpContainer />;
    }

    return (
      <CEPComponent
        lastServedTime={lastMealServedAt}
        servedMealsCount={servedMealsCount}
        incrementServe={this.incrementServe}
        activeTabIndex={this.state.activeTabIndex}
        changeTab={this.changeTab}
        offsetMinutes={offsetMinutes}
      />
    );
  }
}

CEPContainer.propTypes = {
  showLookUp: PropTypes.bool,
  servedMealsCount: PropTypes.number,
};

const mapStateToProps = state => ({
  servedMealsCount: POSSelectors.getServedMealsCount(state),
  showLookUp: POSSelectors.getShowLookUp(state),
  lastMealServedAt: POSSelectors.getLastMealServedAt(state),
  fetching: POSSelectors.getMealCounterFetching(state),
  offsetMinutes: CommonStateSelectors.getOffsetMinutes(state),
});

const mapDispatchToProps = {
  incrementServedMealsCount,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CEPContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/container/CEPContainer.js